var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgGroup22250(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 85,
    height: 85,
    viewBox: "0 0 85 85",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_22250",
    "data-name": "Group 22250",
    transform: "translate(-628 -2045)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_22251",
    "data-name": "Group 22251",
    transform: "translate(333 -781.999)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_5653",
    "data-name": "Rectangle 5653",
    width: 85,
    height: 85,
    rx: 15,
    transform: "translate(295 2826.999)",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("g", {
    id: "_7787561_phone_mobile_smartphone_device_technology_icon",
    "data-name": "7787561_phone_mobile_smartphone_device_technology_icon",
    transform: "translate(616.438 2047.572)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_27661",
    "data-name": "Path 27661",
    d: "M84.663,135H72.933a2.933,2.933,0,1,0,0,5.865H84.663a2.933,2.933,0,1,0,0-5.865Z",
    transform: "translate(-24.736 -83.808)",
    fill: "#6d4eec",
    stroke: "#fff",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_27662",
    "data-name": "Path 27662",
    d: "M64.327,15H43.8A8.824,8.824,0,0,0,35,23.8V56.057a8.824,8.824,0,0,0,8.8,8.8H64.327a8.824,8.824,0,0,0,8.8-8.8V23.8A8.824,8.824,0,0,0,64.327,15Zm2.933,41.057a2.933,2.933,0,0,1-2.933,2.933H43.8a2.933,2.933,0,0,1-2.933-2.933V23.8A2.933,2.933,0,0,1,43.8,20.865H64.327A2.933,2.933,0,0,1,67.259,23.8Z",
    transform: "translate(0 0)",
    fill: "#6d4eec",
    stroke: "#fff",
    strokeWidth: 2
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGroup22250);
export default __webpack_public_path__ + "static/media/Group 22250.76ec6abf0f6572e3b16f16891f492346.svg";
export { ForwardRef as ReactComponent };